import { component } from 'picoapp'
import $ from 'quantdom'
import { debounce } from '../lib/utils'

export default component((node) => {
  //onload check if the url has query param fill=1 and fill the form
  document.addEventListener('DOMContentLoaded', function () {
    onChangeFields.each((field) => {
      $(field).on('change', function () {
        if (window?.gtag) {
          window.gtag('event', 'Ambassador Input - Changed', {
            event_detail: field.name,
          })
        }
      })
    })
  })

  // validate form when required input is changed
  const inputs = $(node).find('input[required], select[required]')
  inputs.each((input) => {
    const type = input.tagName.toLowerCase() == 'select' ? 'select' : input.type
    if (type === 'select') {
      $(input).on('change', function () {
        validateField(input, type)
      })
    } else {
      $(input).on('keydown', function () {
        debounce(() => validateField(input, type), 500)
      })
    }
  })

  const form = document.querySelector('#ambassador-form')
  form.addEventListener('submit', function (e) {
    e.preventDefault()
    setLoading(true)

    if (!validateForm(form)) {
      setLoading(false)
      return
    }

    if (window?.gtag) {
      window.gtag('event', 'Ambassador Form - Submitted', {})
    }

    const data = new FormData(form)
    const action = e.target.action
    $(node).find('button[type="submit"]').attr('disabled', 'disabled')
    $(node).find('button[type="submit"] [data-submit-text]').text('Submitting...')
    fetch(action, {
      method: 'POST',
      body: data,
    })
      .then(() => {
        setLoading(false)
        $(node).find('[data-form-status]').attr('data-form-status', 'success')
        scrollOnScreen(document.querySelector('[data-success-message]'))
      })
      .catch(() => {
        setLoading(false)
      })
  })

  const validateForm = (form) => {
    const inputs = form.querySelectorAll('input[required], select[required]')
    let formValid = true
    let scrollToFirst = null

    inputs.forEach((input) => {
      let type = input.tagName.toLowerCase() == 'select' ? 'select' : input.type
      if (!validateField(input, type)) {
        formValid = false
        if (scrollToFirst === null) {
          scrollToFirst = input
        }
      }
    })

    if (formValid) {
      $(node).find('[data-error-message]').attr('data-error-message', 'false')
    } else {
      $(node).find('[data-error-message]').attr('data-error-message', 'true')
      $(node).find('[data-error-message]').text('Please fill all required fields')

      if (scrollToFirst != null) {
        scrollOnScreen(scrollToFirst)
      }
    }

    return formValid
  }

  const validateField = (input, type) => {
    switch (type) {
      case 'text':
      case 'select':
        if (!input.value) {
          input.classList.add('invalid')
          return false
        } else {
          input.classList.remove('invalid')
          return true
        }
      case 'email':
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!emailRegex.test(input.value)) {
          input.classList.add('invalid')
          return false
        } else {
          input.classList.remove('invalid')
          return true
        }
    }
  }

  const setLoading = (isLoading) => {
    $(node).find('[data-is-form-loading]').attr('data-is-form-loading', isLoading)
    setDisabled(isLoading)
  }

  const setDisabled = (isDisabled) => {
    isDisabled
      ? $(node).find('button[type="submit"]').attr('disabled', 'disabled')
      : document.querySelector('button[type="submit"]').removeAttribute('disabled')
  }

  const scrollOnScreen = (element) => {
    window.scrollTo({
      top: element.getBoundingClientRect().top + window.scrollY - 200,
      behavior: 'smooth',
    })
  }
})
